export default __webpack_public_path__ + "static/stephen-sontag-d19bc0025f933a1b8a6d50122780a013.jpg";